module.exports = __webpack_public_path__ + "static/media/PB_Y_15.789d3ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_15.png
// module id = 244
// module chunks = 0